/**
 * Resolves the Google Maps browser JS API key for Infralytiqs report panels.
 *
 * Priority:
 *   1. `window.IL_EMBED_CONFIG.googleMapsBrowserJSApiKey` — from the Infralytiqs
 *      SDK / client bootstrap (Adobe DAM embed pages).
 *   2. Redux `clientConfig.data.googleMapsBrowserJSApiKey` — first-party app
 *      (e.g. iupdate.productioncloud.io) loaded via `/system/client/config`.
 */

declare global {
  interface Window {
    IL_EMBED_CONFIG?: {
      googleMapsBrowserJSApiKey?: string;
    };
  }
}

export const IL_EMBED_CONFIG_READY_EVENT = 'il-embed-config-ready';

export function readEmbedGoogleMapsApiKey(): string {
  if (typeof window === 'undefined') return '';
  return (window.IL_EMBED_CONFIG?.googleMapsBrowserJSApiKey || '').trim();
}

export function resolveGoogleMapsApiKey(reduxKey?: string | null): string {
  return readEmbedGoogleMapsApiKey() || (reduxKey || '').trim();
}
